import http from "./http";

/* ================= GET ALL ASSIGNED DEVICES & SUMMARY ================= */
export const getAssignedDevices = async () => {
  try {
    const res = await http.get("superadmin/assign_devices.php?action=get_all");
    return res.data;
  } catch (error) {
    return { status: false, message: error.message };
  }
};

/* ================= GET BY SCHOOL ID ================= */
export const getAssignedDevicesBySchool = async (schoolId) => {
  try {
    const res = await http.get(
      `superadmin/assign_devices.php?action=get_by_school&school_id=${schoolId}`
    );
    return res.data;
  } catch (error) {
    return { status: false, message: error.message };
  }
};

/* ================= ADD MULTIPLE DEVICES ================= */
export const addMultipleDevices = async ({ school_id, devices, label }) => {
  try {
    const payload = {
      action: "add_multiple",
      school_id: Number(school_id),
      devices,
      label: label || "",
    };
    const res = await http.post("superadmin/assign_devices.php", payload);
    return res.data;
  } catch (error) {
    return { status: false, message: error.message };
  }
};

/* ================= EDIT ASSIGNED DEVICE ================= */
export const editAssignedDevice = async ({
  id,
  mac_id,
  school_id,
  label,
  status,
}) => {
  try {
    const payload = {
      action: "edit",
      id: Number(id),
      mac_id,
      school_id: school_id ? Number(school_id) : null,
      label: label || "",
      status: status || "assigned",
    };
    const res = await http.post("superadmin/assign_devices.php", payload);
    return res.data;
  } catch (error) {
    return { status: false, message: error.message };
  }
};

/* ================= DELETE ASSIGNED DEVICE ================= */
export const deleteAssignedDevice = async (id) => {
  try {
    // Supports both GET query action=delete and POST payload for safety
    const res = await http.get(
      `superadmin/assign_devices.php?action=delete&id=${id}`
    );
    return res.data;
  } catch (error) {
    return { status: false, message: error.message };
  }
};
